<template>
    <div class="home">
        <technicians />
    </div>
</template>

<script>
    import Technicians from "../components/views/Technicians";
    export default {
        name: "TechniciansView",
        components: {Technicians}
    }
</script>

<style scoped>

</style>
